import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { Session } from "@insite/client-framework/Services/SessionService";
import { getBrandStateById } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadBrand from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrand";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import {
    chain,
    PrepareStructuredPageData,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/GenerateStructuredPageData";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = HandlerWithResult<
    {
        product: ProductModel;
        productInfo?: ProductInfo;
        session: Session;
        brandId?: string | null;
        categoryIdWithBrandId?: string | null;
        categoryId?: string | null;
    },
    { structuredPageData: string }
>;

function stripHtml(html: string | undefined) {
    if (html && typeof window !== "undefined") {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }
}

export const CustomPrepareStructuredPageData: HandlerType = async props => {
    const {
        id,
        productTitle,
        productNumber,
        smallImagePath,
        mediumImagePath,
        largeImagePath,
        canonicalUrl,
        manufacturerItem,
        detail,
        brand: productBrand,
        variantTraits,
    } = props.parameter.product;
    const state = props.getState();

    let isChild = false;
    if (canonicalUrl.includes("?")) {
        isChild = true;
    }

    const isParentChildConnector = variantTraits?.some(variant => variant.nameDisplay === "Parent Child Connector");
    let data = {} as any;
    if (isParentChildConnector && !isChild) {
        data = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: productTitle,
            image: mediumImagePath,
            url: canonicalUrl,
        } as any;
        // const { productInfosById } = state.pages.productDetails;
        // const itemList = [];
        // if (productInfosById) {
        //     let index = 1;
        //     for (const key in productInfosById) {
        //         const product = productInfosById[key];

        //         itemList.push({
        //             "@type": "ListItem",
        //             position: index,
        //             item: {
        //                 "@type": "Product",
        //                 productID: product?.productId,
        //                 name: product?.productId,
        //                 // mpn: manufacturerItem,
        //                 sku: product?.productId,
        //                 url: product?.productDetailPath,
        //             },
        //         });
        //         index++;
        //     }
        // }
        // data = {
        //     "@context": "https://schema.org",
        //     "@type": "ItemList",
        //     itemListElement: itemList,
        // };
    } else {
        data = {
            "@context": "https://schema.org",
            "@type": "Product",
            productID: productNumber,
            name: productTitle,
            description: stripHtml(props.parameter.product.content?.htmlContent),
            image: [smallImagePath, mediumImagePath, largeImagePath],
            // mpn: manufacturerItem,
            sku: productNumber,
            url: canonicalUrl,
        } as any;
    }

    const productInfo = props.parameter.productInfo;
    if (productInfo && isChild) {
        await waitFor(() => !!productInfo.pricing);

        const { pricing } = productInfo;

        if (pricing) {
            data.offers = {
                "@type": "Offer",
                availability: "https://schema.org/InStock",
                price: pricing.unitNetPrice.toFixed(2),
                priceCurrency: props.parameter.session?.currency?.currencyCode,
                url: canonicalUrl,
            };
        }
    }

    // if (!data.offers) {
    //     props.result = { structuredPageData: "" };
    //     return;
    // }

    if (props.parameter.brandId) {
        let brandState = getBrandStateById(state, props.parameter.brandId);
        let brand = productBrand || brandState.value;
        if (!brand && !brandState.isLoading) {
            const awaitableLoadBrand = makeHandlerChainAwaitable(loadBrand);
            await awaitableLoadBrand({ brandId: props.parameter.brandId })(props.dispatch, props.getState);
            brandState = getBrandStateById(props.getState(), props.parameter.brandId);
            brand = brandState.value;
        }

        if (brand) {
            data.brand = {
                "@type": "Brand",
                // identifier: brand.id,
                name: brand.name,
                url: brand.detailPagePath,
            };
        }
    }

    if (props.parameter.categoryIdWithBrandId || props.parameter.categoryId) {
        const category = getCategoryState(
            state,
            props.parameter.categoryIdWithBrandId || props.parameter.categoryId || "",
        ).value;

        if (category) {
            data.category = category.path;
        }
    }

    props.result = { structuredPageData: JSON.stringify(data) };
};

replaceInChain(chain, PrepareStructuredPageData, CustomPrepareStructuredPageData);
